import { IProjectDataKeywords } from "../../types/projectDataKeywords.types"

export enum ProjectActionType {
  FETCH_PROJECT_DATA_KEYWORDS = "FETCH_PROJECT_DATA_KEYWORDS",
  FETCH_PROJECT_DATA_KEYWORDS_SUCCESS = "FETCH_PROJECT_DATA_KEYWORDS_SUCCESS",
  FETCH_PROJECT_DATA_KEYWORDS_ERROR = "FETCH_PROJECT_DATA_KEYWORDS_ERROR",
}

interface FetchProjects {
  type: ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS
}

interface FetchProjectsSuccess {
  type: ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS_SUCCESS
  payload: IProjectDataKeywords[]
}

interface FetchProjectsError {
  type: ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS_ERROR
  payload: string
}

export type ProjectAction = FetchProjects | FetchProjectsSuccess | FetchProjectsError

export interface IProjectState {
  projectDataKeywords: IProjectDataKeywords[]
  loading: boolean
  error: string | null
}
